export const filtersQueryKeys = {
  CREATE_FILTER: 'create-filter'
}
